<template>
  <!-- 首页主容器 -->
  <div class="home_box">
    <!-- 顶部视频和新闻列表区域 -->
    <el-row class="new_list_box">
      <!-- 视频播放区域 -->
      <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12" class="shadow-small video-container">
        <video controls width="100%" height="100%" autoplay loop
          :src="syspArr?.url"></video>
      </el-col>
      <!-- 新闻标签页区域 -->
      <el-col :xs="24" :sm="24" :md="11" :lg="11" :xl="11" class="shadow-small" style="width: calc(100% - 20px);">
        <el-tabs type="border-card">
          <!-- 公司公告标签页 -->
          <el-tab-pane label="公司公告">
            <news-list1 
              :list-data="gsggArr" 
              @item-click="goDetails"
            />
          </el-tab-pane>
          <!-- 企业要闻标签页 -->
          <el-tab-pane label="企业要闻">
            <news-list1 
              :list-data="qyywArr" 
              @item-click="goDetails"
            />
          </el-tab-pane>
        </el-tabs>
      </el-col>
    </el-row>

    <!-- 底部三个栏目区域 -->
    <el-row :gutter="20" class="list_box">
      <!-- 企业风采栏目 -->
      <el-col :xs="23" :sm="23" :md="8" :lg="8" :xl="8" class="list_item">
        <div class="item_title">
          <span class="title_text">企业风采</span>
          <div class="title_link" @click="navTo('/ccYgfc')">
            <span>更多</span>
            <el-icon color="#606266" class="no-inherit">
              <DArrowRight size="14" />
            </el-icon>
          </div>
        </div>
        <news-list2 
          :list-data="qyfcArr" 
          @item-click="goDetails"
        />
      </el-col>

      <!-- 廉政建设栏目 -->
      <el-col :xs="23" :sm="23" :md="8" :lg="8" :xl="8" class="list_item">
        <div class="item_title">
          <span class="title_text">廉政建设</span>
          <div class="title_link" @click="navTo('/ccLzjs')">
            <span>更多</span>
            <el-icon color="#606266" class="no-inherit">
              <DArrowRight size="14" />
            </el-icon>
          </div>
        </div>
        <news-list2 
          :list-data="lzjsArr" 
          @item-click="goDetails"
        />
      </el-col>
      
      <!-- 政策法规栏目 -->
      <el-col :xs="23" :sm="23" :md="8" :lg="8" :xl="8" class="list_item">
        <div class="item_title">
          <span class="title_text">政策法规</span>
          <div class="title_link" @click="navTo('/ccZcfg')">
            <span>更多</span>
            <el-icon color="#606266" class="no-inherit">
              <DArrowRight size="14" />
            </el-icon>
          </div>
        </div>
        <news-list2 
          :list-data="zcfgArr" 
          @item-click="goDetails"
        />
      </el-col>
    </el-row>

    <!-- 公司组件 -->
    <companyZj :companyNub="companyNub" />
  </div>
</template>

<script>
import { DArrowRight } from "@element-plus/icons-vue";
import { ref, onBeforeMount, watch, onMounted } from "vue";
import { useStore } from 'vuex';
import router from "@/router";
import http from "@/utils/api";
import companyZj from "@/components/companyZj.vue";
import NewsList1 from "@/components/news/newsList1.vue";
import NewsList2 from "@/components/news/newsList2.vue";

export default {
  components: {
    DArrowRight,
    companyZj,
    NewsList1,
    NewsList2
  },
  setup() {
    const store = useStore();
    const companyNub = ref(1);
    const retryTimer = ref(null); // 重试定时器
    
    // 新闻数据
    const qyywArr = ref([]);
    const gsggArr = ref([]);
    const qyfcArr = ref([]);
    const lzjsArr = ref([]);
    const syspArr = ref({});
    const zcfgArr = ref([]);

    // 定义新闻类型常量
    const NEWS_TYPES = {
      LBT: 'ccLbt',
      QYYW: 'ccQyyw',
      GSGG: 'ccGsgg',
      YGFC: 'ccYgfc',
      LZJS: 'ccLzjs',
      SYSP: 'ccSysp',
      ZCFG: 'ccZcfg'
    };

    // 获取页面数据
    const getAdd = async () => {
      const usersObj = JSON.parse(sessionStorage.getItem("userInfo"));
      
      try {
        // 构建查询条件
        const types = Object.values(NEWS_TYPES).join(',');
        const where = `FIND_IN_SET(type,'${types}');`;
        
        const res = await http.base.NewsQuery({
          page: 1,
          limit: 99,
          orgId: '',
          date: "",
          select: "type,url,createDate,content,title,secTitle,id",
          where: where,
          sortby: "sort desc",
        });

        if (res?.code === 0) {
          // 根据类型分类数据
          const allData = res.data.data || [];
          
          qyywArr.value = allData.filter(item => item.type.includes(NEWS_TYPES.QYYW)).slice(0, 3);
          gsggArr.value = allData.filter(item => item.type.includes(NEWS_TYPES.GSGG)).slice(0, 3);
          qyfcArr.value = allData.filter(item => item.type.includes(NEWS_TYPES.YGFC)).slice(0, 6);
          lzjsArr.value = allData.filter(item => item.type.includes(NEWS_TYPES.LZJS)).slice(0, 6);
          
          const syspData = allData.filter(item => item.type.includes(NEWS_TYPES.SYSP));
          syspArr.value = syspData.length > 0 ? syspData[0] : {};
          
          zcfgArr.value = allData.filter(item => item.type.includes(NEWS_TYPES.ZCFG)).slice(0, 5);
        }
      } catch (error) {
        console.error("获取数据失败:", error);
        // 登录失败时3秒后重试
        if (retryTimer.value) clearTimeout(retryTimer.value);
        retryTimer.value = setTimeout(() => {
          if (store.state.isLoggedIn) {
            getAdd();
          }
        }, 3000);
      }
    };

    // 监听登录状态变化
    watch(() => store.state.isLoggedIn, (newVal) => {
      if (newVal) {
        getAdd();
      }
    });

    // 组件挂载时检查登录状态
    onMounted(() => {
      if (store.state.isLoggedIn) {
        getAdd();
      }
    });

    // 组件卸载时清除定时器
    onBeforeMount(() => {
      if (retryTimer.value) {
        clearTimeout(retryTimer.value);
        retryTimer.value = null;
      }
    });

    // 导航跳转方法
    const navTo = (url) => {
      router.push({
        path: url,
      });
    };
    
    // 跳转到新闻详情页
    const goDetails = (item) => {
      const { id, url } = item;
      
      const routeParams = {
        path: "",
        query: {id}
      };

      if (url) {
        const fileType = determineFileType(url);
        routeParams.path = fileType === "PDF" || fileType === "视频" 
          ? "/fileDetails" 
          : "/listDetails";
      } else {
        routeParams.path = "/listDetails";
      }

      router.push(routeParams);
    };

    // 确定文件类型
    const determineFileType = (url) => {
      if (!url) return;
      const extension = url.split(".").pop().toLowerCase();
      switch (extension) {
        case "jpeg":
        case "jpg":
        case "png":
        case "gif":
        case "bmp":
          return "图片";
        case "mp4":
        case "avi":
        case "mov":
        case "mkv":
        case "webm":
          return "视频";
        case "pdf":
          return "PDF";
        default:
          return "未知类型";
      }
    };

    return {
      companyNub,
      qyywArr,
      gsggArr,
      qyfcArr,
      lzjsArr,
      syspArr,
      zcfgArr,
      navTo,
      goDetails
    };
  }
}
</script>

<style scoped lang="scss">
	::v-deep .el-tabs--border-card>.el-tabs__header .el-tabs__item.is-active {
		color: rgb(5, 174, 5);
		font-weight: bold;
	}

	::v-deep .el-card {
		padding: 10px 10px 10px 10px;
	}

	::v-deep .el-card__body {
		padding: 0px;
		box-sizing: border-box;
	}

	::v-deep .el-divider--horizontal {
		margin: 20px 0;
	}

	.companyZj_box {
		width: 1920px;
		height: 500px;
		background-color: #ccc;
	}

.new_list_box {
  width: 100%;
  margin-bottom: 20px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  background: #fff;
  padding-top: 20px;

  .shadow-small {
    box-shadow: 0 3px 5px rgba(0, 0, 0, 0.175);
    height: 100%;
    border-radius: 0.25rem;
    border: solid 1px rgba(0, 0, 0, 0.125);
    
    .tab_box {
      height: 300px;
      overflow-y: scroll;

      .tab_item {
        width: 100%;
        margin: 0 auto;
        height: 110px;
        border-bottom: 1px solid #ccc;

        .time {
          width: 74px;
          height: 80px;
          border: 2px #93bf5d solid;
          background: #93bf5d;
          font-family: "Georgia";
          margin-right: 15px;
          text-align: center;
          padding-top: 10px;

          .year {
            background-color: #fff;
          }

          .day {
            height: 38px;
            font-size: 22px;
            color: #fff;
          }
        }

        .con {
          overflow: hidden;

          .intro {
            font-size: 14px;
            color: #888;
          }

          .word-more {
            font-size: 18px;
            text-decoration: none;
            color: #333;
            transition: all 0.5s ease;
            padding-bottom: 10px;
          }
        }
      }
    }
  }

  .video-container {
    display: flex;
    flex-direction: column;
    
    video {
      display: block; /* 去除视频下方的空白 */
      object-fit: cover; /* 保持视频比例同时填充容器 */
    }
  }
}

.home_box {
  width: 100%;

  .hzdw_box {
    width: 100%;
    height: 110px;
    border-bottom: 1px solid rgb(3, 125, 9);
    padding: 0px 10px;
    border-bottom: none;

    .dw_conten {
      width: 100%;
      height: 76px;
    }

    .dw_item {
      width: 260px;
      height: 66px;
      margin-right: 10px;
      border: 1px solid #ccccccb5;

      img {
        width: 100%;
        height: 100%;
      }
    }
  }

  .list_box {
    min-height: 270px;
    margin-bottom: 20px;
    display: flex;
    justify-content: space-between;

    .list_item {
      width: 100%;
      min-height: 270px;
      font-size: 14px;

      .item_conten {
        width: 100%;
        height: calc(100% - 40px);
        padding: 10px 10px 0px 20px;

        .item_text {
          text-overflow: ellipsis;
          white-space: nowrap;
          overflow: hidden;
          height: 34px;
        }
      }

      //标题
      .item_title {
        height: 40px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 0px 10px 0px 0px;
        font-size: 14px;
        border-bottom: 2px solid #e9e6e679;
        color: rgb(5, 174, 5);
        font-weight: bold;
        font-size: 16px;
        
        .title_text {
          text-align: center;
          min-width: 100px;
          line-height: 40px;
          border-bottom: 2px solid rgb(5, 174, 5);
        }
        
        .title_link {
          color: #606266;
          line-height: 14px;
          font-weight: 500;
          display: flex;
          align-items: center;
        }
      }
    }
  }
}

@media screen and (max-width: 768px) {
  .flex_bw_center {
    display: flex;
    flex-direction: column;
  }

  .list_item:first-child {
    padding-top: 20px;
  }
  
  .list_item:nth-child(2n + 1) {
    background: #fff;
  }
  
  .new_list_box {
    display: flex;
    flex-direction: column-reverse;
    margin-bottom: 0px;
    background: #fff;
    
    .video-container {
      height: 200px; /* 移动端设置固定高度 */
      margin-top: 20px;
      
      video {
        height: 100%;
      }
    }
    
    .shadow-small:nth-child(1) {
      box-shadow: none !important;
      border-radius: 0;
      border: 0 !important;
    }
  }
  
  .list_box {
    justify-content: center;
  }
  
  .list_item {
    margin: 0px 10px;
  }
}
</style>